import type { ReactNode } from "react";
import type { Permission } from "@hostdock/types";
import { PermissionDenied } from "@hostdock/ui";
import { useSession } from "../session";

/** Renders a permission-denied state instead of a page the admin cannot use. The API enforces access regardless. */
export function RequirePermission({ anyOf, children }: { anyOf: Permission[]; children: ReactNode }) {
  const { can } = useSession();
  return anyOf.some(can) ? <>{children}</> : <PermissionDenied />;
}
